export const SUPPORT_BOOK_A_CALL_URL =
  "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1Ph0klvkcZpm7nclYnkQn_v9_BfXgmrGy-qfKaicqPZxVlgN-j0ZLp6QAG0bJlWBoYtcOiEqSH";
